module.exports = __webpack_public_path__ + "images/loading.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/loading.gif
 ** module id = 445
 ** module chunks = 0
 **/